import { render, staticRenderFns } from "./customer-form.vue?vue&type=template&id=5a9fe07e&"
import script from "./customer-form.vue?vue&type=script&lang=js&"
export * from "./customer-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports